module.exports = __webpack_public_path__ + "static/media/media-three.54e6af69.png";